'use es6';

import get from 'transmute/get';
export const getId = user => get('user_id', user) || get('id', user);
export const getFirstName = user => get('first_name', user) || get('firstName', user);
export const getLastName = user => get('last_name', user) || get('lastName', user);
export const getEmail = get('email');